import { render, staticRenderFns } from "./PopoverCommentActions.vue?vue&type=template&id=e9384212&scoped=true"
import script from "./PopoverCommentActions.vue?vue&type=script&lang=js"
export * from "./PopoverCommentActions.vue?vue&type=script&lang=js"
import style0 from "./PopoverCommentActions.vue?vue&type=style&index=0&id=e9384212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9384212",
  null
  
)

export default component.exports